export const managePortfolioSearch = (list, id) => {
    const newList = [...list];
    const idKey = Object.keys(list[0]).find(key => key.includes('Id'));
    const itemIndex = list.findIndex(item => item[idKey] === id);
    newList[itemIndex].isPortfolioItem = !newList[itemIndex].isPortfolioItem;
    return newList;
}